export default __webpack_public_path__ + "static/media/xMovie.dd5d72c9.mp4";